"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Icon_1 = __importDefault(require("../../Icon"));
var CloseIcon = function (_a) {
    var closeIcon = _a.closeIcon, isLoading = _a.isLoading;
    if (isLoading)
        return null;
    return (closeIcon || react_1.default.createElement(Icon_1.default, { kind: "close", fontSize: "small" }));
};
exports.default = CloseIcon;
